<template lang="pug">
    img(
        v-bind="image"
    )
</template>

<script>
export default {
    name: 'GalleryImage',
    props: {
        src: {
            type: String,
            required: true,
        },
        height: {
            type: Number,
            required: true,
        },
        width: {
            type: Number,
            required: true,
        },
        alt: {
            type: String,
            default: '',
        },
        isLazy: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        image() {
            const obj = {
                src: this.src,
                alt: this.alt,
                width: this.width,
                height: this.height,
                class: '',
            }

            if (this.isLazy) obj.loading = 'lazy'

            return obj
        },
    },
}
</script>
